import React from "react";

import CheckCircleIcon from "./check-circle-icon";
import PlusIcon from "./plus-icon";

interface ApplyButtonProps {
  textSize: string;
  iconSize: number;
  className?: string;
  isPromoAlreadyApplied?: boolean;
  applyButtonLabel: string;
  appliedButtonLabel: string;
  isButtonDisabled?: boolean;
  promoCode: string;
  onApplyPromoCode: () => Promise<void>;
  style?: React.CSSProperties;
  fontWeight?: string;
  underlineClass?: string;
  positionClass?: string;
}

export default function ApplyButton({
  textSize,
  iconSize,
  className = "",
  isPromoAlreadyApplied,
  applyButtonLabel,
  appliedButtonLabel,
  isButtonDisabled,
  promoCode,
  onApplyPromoCode,
  style,
  fontWeight = "font-[600]",
  underlineClass = "underline underline-offset-4",
  positionClass = "",
}: Readonly<ApplyButtonProps>) {
  const buttonLabel = isPromoAlreadyApplied
    ? appliedButtonLabel
    : applyButtonLabel;

  return (
    <button
      type="button"
      onClick={onApplyPromoCode}
      disabled={isButtonDisabled || isPromoAlreadyApplied}
      className={`flex items-center gap-[4px] ${fontWeight} ${
        isPromoAlreadyApplied ? "" : underlineClass
      } hover:opacity-80 transition-opacity whitespace-nowrap ${textSize} ${className}`}
      style={style || { color: "#E8F7E9" }}
      aria-label={`${buttonLabel} ${promoCode}`}
      id="promo-code-banner-apply-button"
    >
      <span className="pointer-events-none">
        {isPromoAlreadyApplied ? (
          <CheckCircleIcon size={iconSize} />
        ) : (
          <PlusIcon size={iconSize} />
        )}
      </span>
      {isPromoAlreadyApplied ? (
        <span className={`pointer-events-none font-[600] ${positionClass}`}>
          {buttonLabel}
        </span>
      ) : (
        <span className={`pointer-events-none ${positionClass}`}>
          {buttonLabel}
        </span>
      )}
    </button>
  );
}
